import React from 'react'
import Navbar from '../navbar'
import Aboutus from '../Aboutus'
import Footer from '../Footer'

const About = () => {
    return (
        <>
            <Navbar />

            <Aboutus />

            <Footer />
        </>
    )
}

export default About